<template>
<div class="page-about-us">
  <component v-for="section in sections"
             :is="section.component"
             :section="section.data"
             :key="section.id"
             :namespace="section.namespace"
  />
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import AboutUsPromoSection from '@/components/about-us/sections/AboutUsPromoSection'
import AboutUsCardsSection from '@/components/about-us/sections/AboutUsCardsSection'
import AboutUsStaffSection from '@/components/about-us/sections/AboutUsStaffSection'
import AboutUsImageSection from '@/components/about-us/sections/AboutUsImageSection'
import AboutUsFeedbackSection from '@/components/about-us/sections/AboutUsFeedbackSection'
import InjectsSeo from '@/mixins/InjectsSeo'

export default {
  mixins: [InjectsSeo],

  metaInfo() {
    return this.getMetaInfoFromSettings(this.aboutUsSeo)
  },

  computed: {
    ...mapGetters({
      aboutUsSections: 'settings/aboutUsSections',
      aboutUsSeo: 'settings/aboutUsSeo',
    }),

    sections() {
      const random = Math.random().toString().replace('.', '_')

      return [
        {
          id: `about-us-section-promo-${random}`,
          component: AboutUsPromoSection,
          data: this.aboutUsSections.promo,
          display: this.aboutUsSections.promo.display,
          namespace: 'about_us_promo',
        },
        {
          id: `about-us-section-cards-${random}`,
          component: AboutUsCardsSection,
          data: this.aboutUsSections.cards,
          display: this.aboutUsSections.cards.display,
          namespace: 'about_us_cards',
        },
        {
          id: `about-us-section-technology-${random}`,
          component: AboutUsCardsSection,
          data: this.aboutUsSections.technology,
          display: this.aboutUsSections.technology.display,
          namespace: 'about_us_technology',
        },
        {
          id: `about-us-section-staff-${random}`,
          component: AboutUsStaffSection,
          data: this.aboutUsSections.staff,
          display: this.aboutUsSections.staff.display,
          namespace: 'about_us_staff',
        },
        {
          id: `about-us-section-quality-${random}`,
          component: AboutUsImageSection,
          data: this.aboutUsSections.quality,
          display: this.aboutUsSections.quality.display,
          namespace: 'about_us_quality',
        },
        {
          id: `about-us-section-feedback-${random}`,
          component: AboutUsFeedbackSection,
          data: this.aboutUsSections.feedback,
          display: this.aboutUsSections.feedback.display,
          namespace: 'about_us_feedback',
        },
      ].filter(s => !!s.display)
    }
  },
}
</script>

<style lang="less">
.page-about-us {
  .about-us-section {
    &:not(.about-us-section-without-context-background) {
      &:nth-child(odd) {
        @apply bg-primary-lighter;

        .about-us-section-icon {
          @apply text-black;
        }
      }
    }
  }
}
</style>
